import React from 'react';
import {OrderType} from "../../services/Api/types";
import {ReactComponent as DineInIco} from "../../../images/icons/dine-in.svg";
import {ReactComponent as RoomServiceIco} from "../../../images/icons/room-service.svg";
import {ReactComponent as PickUpIco} from "../../../images/icons/pick-up.svg";
import {ReactComponent as DeliveryIco} from "../../../images/icons/car.svg";

interface Props {
    orderType: OrderType;
}

const OrderTypeIcon = ({orderType}: Props) => {
    const drawIcon = (): JSX.Element => {
        switch (orderType) {
            case OrderType.DELIVERY:
                return <DeliveryIco/>;
            case OrderType.PICK_UP:
                return <PickUpIco/>;
            case OrderType.ROOM_SERVICE:
                return <RoomServiceIco/>;
            case OrderType.DINE_IN:
                return <DineInIco/>;
        }
    };

    return drawIcon();
}

export default OrderTypeIcon;